<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content" data-title="借用他组_试剂采购库存管理系统">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="search-wrapper">
              <el-input v-model="searchData.reagentName" placeholder="请输入关键字" prefix-icon="el-icon-search"
                        type="text" @keyup.enter.native="borrowList"/>
            </div>
<!--            <div class="search-wrapper">-->
<!--              <span>状态选择</span>-->
<!--              <el-select v-model="searchData.operation" placeholder="请选择" @change="getRecord()">-->
<!--                <el-option v-for="item in operations" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </div>-->
            <div class="search-wrapper">
                <el-button type="primary" size="small" class="cursorPointer" @click="borrowList">
                快速查询
              </el-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-container">
        <el-table :data="borrowData" :header-cell-style="{background: '#F8FAFC',color: '#000000',fontWeight: 700,height: '54px',}"
            border style="width: 100%" class="supTable">
          <template slot="empty"><img src="../../assets/images/emptyCabinet.png" class="empty" /><p>暂无跨组借用信息</p></template>
          <el-table-column prop="reagentCode" label="试剂编号" width="110px"></el-table-column>
          <el-table-column prop="reagentName" label="试剂名称"></el-table-column>
          <el-table-column prop="casNo" label="CAS号"></el-table-column>
          <el-table-column prop="belongTaskName" label="所属课题组"></el-table-column>
          <el-table-column prop="borrowUserName" label="借用人"></el-table-column>
          <el-table-column prop="subscribeTime" label="申请借用时间" width="160px"> </el-table-column>
          <el-table-column prop="takingUserName" label="帮助领取人"></el-table-column>
          <el-table-column prop="leaveTime" label="出库时间" width="160px"> </el-table-column>
          <el-table-column prop="givebackUserName" label="归还人" :formatter="getGivebackName"></el-table-column>
          <el-table-column prop="giveBackTime" label="归还入库时间" width="160px"> </el-table-column>
        </el-table>
      </div>
      <Pagination :dataTotal="total" :totalpage="totalpage" :pagesize="searchData.pageSize" @changePage="changePage"></Pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {EventBus} from "@/config/event-bus";
export default {
  data() {
    return {
      searchData: {
        reagentName: "",
        operation: "",
        pageNum: 1,
        pageSize: 10,
        borrowRole: 1,
      },
      borrowData: [],
      total: 0,
      totalpage: 0,
      operations: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "转借申请中",
        },
        {
          value: 1,
          label: "转借完成",
        },
        {
          value: 2,
          label: "转借失败",
        },
        {
          value: 3,
          label: "已拒绝",
        },
        {
          value: 4,
          label: "已取消",
        },
        {
          value: 5,
          label: "已同意",
        },
        {
          value: 6,
          label: "已归还",
        },
      ],
      userId: "",
    };
  },
  created() {
    const { visitType } = this.$route.query;
    if (visitType == "4") {
      this.searchData.operation = this.operations[4].value;
    } else if (visitType == "5") {
      this.searchData.operation = this.operations[5].value;
    }
    this.borrowList();
    this.getUserId();
  },
  filters: {
    timeYMD(str) {
      return moment(str).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    getGivebackName(row){
      if(null != row.giveBackTime){
        return row.givebackUserName;
      }else {
        return null;
      }
    },
    getUserId() {
      const user = JSON.parse(localStorage.getItem("userInfo"));
      this.userId = user.id;
    },

    getRecord() {
      // 筛选
      this.searchData.pageNum = 1;
      this.borrowList();
    },
    //借用列表
    borrowList() {
      let params = this.searchData;
      this.$apiFetch
        .get("/lockerReagentBorrow/queryBorrowRecordOther", params)
        .then((res) => {
          this.borrowData = res.data.list;
          this.total = res.data.total;
          this.totalpage = res.data.pages;
        });
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.borrowList();
    },
  },
};
</script>
<style lang="less" scoped>
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      display: flex;
      align-items: center;
      .search-wrapper {
        margin-right: var(--zng-gap);
        span{
          margin-right: 10px;
        }
        .el-input {
          width: 260px;
        }
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
}
.supTable {
  img {
    width: 100px;
    height: 100px;
  }
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
</style>
